import { AsyncPipe } from '@angular/common';
import { Component, Input, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import QRCode from 'qrcode';
import { filter, from, map, mergeMap } from 'rxjs';
import { Item } from 'src/app/models';
import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
  selector: 'app-item-public-link',
  template: `
    <div class="flex flex-col justify-start items-center">
      @if (shopfrontUrl$ | async; as shopfrontUrl) {
        @if (qrCodeToggled()) {
          <img [src]="qrCodeImage$ | async" alt="" />
        }
        <div class="flex flex-row justify-center items-center gap-x-1">
          <a
            mat-stroked-button
            [href]="shopfrontUrl"
            target="_blank"
            class="flex-shrink-0"
            >Public Link</a
          >
          <mat-icon [matTooltip]="qrCodeHelpText" class="text-gray-300"
            >help
          </mat-icon>
          <button
            mat-icon-button
            (click)="qrCodeToggled.set(!qrCodeToggled())"
            [matTooltip]="qrCodeToggled() ? 'Show QR Code' : 'Hide QR Code'"
          >
            <mat-icon>qr_code</mat-icon>
          </button>
        </div>
      }
    </div>
  `,
  standalone: true,
  imports: [MatButtonModule, MatTooltipModule, MatIcon, AsyncPipe]
})
export class ItemPublicLinkComponent {
  @Input() item: Item;

  shopfrontUrl$ = this.configService.currentUser.pipe(
    filter((user) => user !== null),
    map(
      (user) =>
        'https://' +
        user?.tenant?.shopfront_url +
        '/item-information/' +
        this.item.uuid
    )
  );

  qrCodeToggled = signal(false);

  qrCodeImage$ = this.shopfrontUrl$.pipe(
    mergeMap((url: string) => from(QRCode.toDataURL(url)))
  );

  qrCodeHelpText =
    'Label the item with this QR code, your customers can then scan it to view documents and information about the item.';

  constructor(private configService: ConfigService) {}
}
